/**
 * Takes a function and immediately calls it with no args.
 * @param fn The function to apply
 * @example cleanupFunctions.forEach(apply);
 */
export function apply(fn) {
    fn();
}

/**
 * Just needed a convenient place to put this logic.
 * utils.ts is low level enough that it makes sense for now.
 *
 * If a radio stat's channel number is <= 400, treat it as
 * a channel number.
 * If the channel number is > 400, treat it as a value in MHz
 *
 * @param {number} channel
 */
export function isRadioStatChannelAFrequency(channel: number) {
    return channel && channel > 400;
}

/**
 * Takes an object and turns it into a space separated string of it's keys where the corresponding values are truthy
 * @example classObj({this: true, that: false, what: 1}) === 'this what'
 */
export function classObj(obj: unknown): string {
    return Object.keys(obj)
        .filter((key) => !!obj[key])
        .join(' ');
}

export class Metrics {
    private readonly _performance: Performance;
    constructor(performance: Performance) {
        this._performance = performance;
    }

    /**
     * Mark the beginning and end of a promise execution.
     * Pass the promise instance directly into this function and you'll get it back out as well.
     */
    async measure<T = any>(tag: string, promise: Promise<T>): Promise<T> {
        this._performance.mark(`${tag}#start`);
        try {
            return await promise;
        } finally {
            this._performance.mark(`${tag}#end`);
            this._performance.measure(`${tag}`, `${tag}#start`, `${tag}#end`);
        }
    }
}

export function isNullOrUndefined(v) {
    return v == null;
}

export function isArray(v) {
    return Array.isArray(v);
}

export function isNotNil(v) {
    // is it anything but null or undefined
    return v != null;
}
